import moment from 'moment';

export const formatSummary = (data = {}, inspectionTime = {}) => {
  const price = inspectionTime.stationInfo?.estimatedSolarEnergyUnitPrice || 0;
  if (!data) return {};
  const round = (n) => Math.round(Number(n) || 0);
  const toCard = (obj = {}) => ({
    value: round(obj.value),
    unit: 'kWh',
    subtitle:
      '≈ ¥ ' +
      (obj.value * price).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    change: obj.delta != null ? round(obj.delta) : 0,
  });
  return {
    daily: toCard(data.daily),
    weekly: toCard(data.weekly),
    monthly: toCard(data.monthly),
    yearly: toCard(data.yearly),
    lifetime: {
      value: round(data.lifetime),
      unit: 'kWh',
      subtitle:
        '≈ ¥ ' +
        (data.lifetime * price).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      change: '',
    },
  };
};

export async function initializeStation(props) {
  let stations = props.userStationList;
  if (!Array.isArray(stations) || stations.length === 0) {
    stations = await props.getUserStationList();
  }
  if (!props.inspectionTime.stationId && stations[0]) {
    props.inspectionTimeUpdate({
      ...props.inspectionTime,
      stationId: stations[0].stationId,
      stationInfo: stations[0],
    });
  } else if (props.inspectionTime.stationId && !props.inspectionTime.stationInfo) {
    const info = stations.find((s) => s.stationId === props.inspectionTime.stationId);
    if (info) {
      props.inspectionTimeUpdate({ ...props.inspectionTime, stationInfo: info });
    }
  }
  if (!props.inspectionTime.range) {
    props.inspectionTimeUpdate({ ...props.inspectionTime, range: 'd' });
  }
  if (!props.inspectionTime.date) {
    props.inspectionTimeUpdate({
      ...props.inspectionTime,
      date: moment().format('YYYY-MM-DD'),
    });
  }
}
